import React, { useState } from "react";
import {
  Box,
  Typography,
  IconButton,
  Avatar,
  Popover,
  Divider,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Badge,
  Button,
  Backdrop
} from "@mui/material";
import NotificationsNoneOutlinedIcon from "@mui/icons-material/NotificationsNoneOutlined";
import { esignIcons } from "../Esign/icons";

// const notifications = [
//   {
//     title: "ESign in Progress",
//     description:
//       "We’ve sent your document for signing — you’ll be notified once it’s completed.",
//     time: "45 min ago",
//     dateGroup: "TODAY",
//   },
//   {
//     title: "Signature Pending",
//     description: "A document is still waiting for signatures.",
//     time: "45 min ago",
//     dateGroup: "TODAY",
//   },
//   {
//     title: "Partial Signatures Received",
//     description:
//       "Some recipients have completed their signatures — but a few are still pending.",
//     time: "45 min ago",
//     dateGroup: "YESTERDAY",
//   },
//   {
//     title: "ESign in Progress",
//     description:
//       "We’ve sent your document for signing — you’ll be notified once it’s completed.",
//     time: "45 min ago",
//     dateGroup: "YESTERDAY",
//   },
//   {
//     title: "Signature Pending",
//     description: "A document is still waiting for signatures.",
//     time: "45 min ago",
//     dateGroup: "YESTERDAY",
//   },
// ];

const notifications = [];
const NotificationsUI = () => {
  const [anchorElNotification, setAnchorElNotification] = useState(null);

  const handleClick = (event) => {
    setAnchorElNotification(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorElNotification(null);
  };

  const open = Boolean(anchorElNotification);

  const groupedNotifications = notifications.reduce((acc, item) => {
    acc[item.dateGroup] = acc[item.dateGroup] || [];
    acc[item.dateGroup].push(item);
    return acc;
  }, {});

  return (
    <Box>
      <IconButton onClick={handleClick}>
        {esignIcons.notificationIcon}
      </IconButton>
      <Backdrop open={open} onClick={handleClose} sx={{ zIndex: 999, color: '#fff', backgroundColor: "rgba(0,0,0,0.1)" }} />
      <Popover
        open={open}
        anchorEl={anchorElNotification}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{
          sx: {
            p: 0,
            width: "29vw",
            height: "85vh",
            borderRadius: "12px",
            display: "flex",
            flexDirection: "column",
            boxShadow: "none"
          },
        }}
      >
        {/* Sticky Header */}
        <Box
          sx={{
            position: "sticky",
            top: 0,
            zIndex: 1,
            backgroundColor: "#fff",
            p: 2,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderBottom: "1px solid #e0e0e0",
            height: "64px",
          }}
        >
          <Typography
            sx={{
              fontSize: "18px",
              fontWeight: 600,
              lineHeight: "100%",
            }}
          >
            Notifications
          </Typography>
          <Button
            variant="text"
            sx={{
              fontSize: "14px",
              fontWeight: 500,
              lineHeight: "100%",
              textTransform: "none",
            }}
          >
            {/* Mark all as read */}
          </Button>
        </Box>

        {/* Scrollable Body */}
        <Box
          sx={{
            flex: 1,
            overflowY: "auto",
            px: 0,
          }}
        >
          {Object.keys(groupedNotifications).length === 0 ? (
            <Box
              height="100%"
              display="flex"
              justifyContent="center"
              alignItems="center"
              sx={{ py: 4 }}
            >
              <Typography variant="body1" color="text.secondary">
                No notifications
              </Typography>
            </Box>
          ) : (
            <List disablePadding>
              {Object.entries(groupedNotifications).map(
                ([dateGroup, items], index) => (
                  <Box key={dateGroup}>
                    <Typography
                      variant="body2"
                      px={2}
                      pt={2}
                      color="text.secondary"
                      fontWeight="bold"
                      sx={{
                        fontSize: "13px",
                        fontWeight: 500,
                        lineHeight: "100%",
                        pb: 1,
                      }}
                    >
                      {dateGroup}
                    </Typography>
                    {items.map((item, idx) => (
                      <ListItem
                        key={`${dateGroup}-${idx}`}
                        alignItems="flex-start"
                        sx={{ px: 2, py: 0 }}
                      >
                        <ListItemAvatar>
                          <Avatar
                            sx={{ bgcolor: "#F6F1FE", width: 42, height: 42 }}
                          >
                            {esignIcons.notificationTextIcon}
                          </Avatar>
                        </ListItemAvatar>
                        <ListItemText
                          primary={
                            <Typography
                              sx={{
                                fontSize: "15px",
                                fontWeight: 500,
                                lineHeight: "24px",
                              }}
                            >
                              {item.title}
                            </Typography>
                          }
                          secondary={
                            <>
                              <Typography
                                component="span"
                                variant="body2"
                                color="text.secondary"
                                mt={0.5}
                                sx={{
                                  fontWeight: 400,
                                  fontSize: "13px",
                                  lineHeight: "20px",
                                }}
                              >
                                {item.description}
                              </Typography>
                              <Typography
                                variant="caption"
                                display="block"
                                color="text.secondary"
                                mt={0.5}
                                sx={{
                                  fontWeight: 400,
                                  fontSize: "11px",
                                  lineHeight: "24px",
                                }}
                              >
                                {item.time}
                              </Typography>
                            </>
                          }
                        />
                      </ListItem>
                    ))}
                  </Box>
                )
              )}
            </List>
          )}
        </Box>

        {/* Sticky Footer */}
        <Box
          sx={{
            position: "sticky",
            bottom: 0,
            backgroundColor: "#fff",
            p: 2,
            borderTop: "1px solid #e0e0e0",
            height: "64px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {/* <Button
            variant="text"
            sx={{
              fontSize: "16px",
              fontWeight: 500,
              lineHeight: "100%",
              textTransform: "none",
            }}
          >
            See More
          </Button> */}
        </Box>
      </Popover>
    </Box>
  );
};

export default NotificationsUI;
